/**
 * Frontend telemetry — technical metrics only, no PII.
 * Active in dev or when localStorage flag 'telemetry' is set.
 * Incluir workspace_id e rota permite medir por tenant e por tela (Fase 9 — observabilidade).
 */

const ENABLED =
  typeof import.meta !== "undefined" && import.meta.env?.DEV === true ||
  (typeof localStorage !== "undefined" && localStorage.getItem("telemetry") === "1");

let realtimeChannelsCount = 0;
let inboxRefetchCount = 0;
const hookMountCounts: Record<string, number> = {};

export interface TelemetryContext {
  workspaceId?: string | null;
  route?: string;
}

function log(label: string, payload: Record<string, number | string | boolean | null | undefined>) {
  if (!ENABLED) return;
  try {
    console.log(`[telemetry] ${label}`, payload);
  } catch {
    // no-op
  }
}

/** Log com contexto de workspace e rota para identificar maiores multiplicadores (dashboard, chat, unread). */
export function logWithContext(
  label: string,
  payload: Record<string, number | string | boolean>,
  context?: TelemetryContext
) {
  if (!ENABLED) return;
  try {
    const full: Record<string, number | string | boolean | null | undefined> = { ...payload };
    if (context?.workspaceId != null) full.workspace_id = context.workspaceId ?? undefined;
    if (context?.route) full.route = context.route;
    console.log(`[telemetry] ${label}`, full);
  } catch {
    // no-op
  }
}

export function bootstrapEnd(t0: number) {
  const elapsed = Math.round(performance.now() - t0);
  log("bootstrapEnd", { elapsedMs: elapsed });
}

export function dashboardFirstPaint(t0: number, context?: TelemetryContext) {
  const elapsed = Math.round(performance.now() - t0);
  if (context) {
    logWithContext("dashboardFirstPaint", { elapsedMs: elapsed }, context);
  } else {
    log("dashboardFirstPaint", { elapsedMs: elapsed });
  }
}

export function realtimeChannelsCountSet(count: number) {
  realtimeChannelsCount = count;
  log("realtimeChannelsCount", { count });
}

export function realtimeChannelsCountDelta(delta: number) {
  realtimeChannelsCount = Math.max(0, realtimeChannelsCount + delta);
  log("realtimeChannelsCount", { count: realtimeChannelsCount });
}

export function hookMountCount(hookName: string) {
  hookMountCounts[hookName] = (hookMountCounts[hookName] || 0) + 1;
  log("hookMountCount", { hookName, count: hookMountCounts[hookName] });
}

export function inboxRefetchIncrement() {
  inboxRefetchCount += 1;
  log("inboxRefetchCount", { count: inboxRefetchCount });
}

export function getInboxRefetchCount(): number {
  return inboxRefetchCount;
}

export function isTelemetryEnabled(): boolean {
  return ENABLED;
}
